<template>
  <div>
    <div class="navtitleright nb">
      <a href="page.html">首页</a>
      <span class="color-change" v-for="(item, index) in productInfo.classPath" :key="index">
        > <a @click="_jumpToPageByClassId(item.classId)">{{item.className}}</a>
      </span>
    </div>
    
    <div class="indbody pro-style">
      <el-row class="nb recom-box">
        <el-col :span="24">
          <div class="part-price-sort">
            <ul class="pps">
              <li class="readychoose">
                <div class="lside-name">已选择</div>
                <div class="rside-navtitle">
                  <a @click="_jumpToPageByCancel('class')" v-if="productInfo.goodsClass.hktName" title="取消选择" style="margin-right:10px;">
                    分类：<span>{{productInfo.goodsClass.hktName}}<em>×</em></span>
                  </a>
                  <a @click="_jumpToPageByCancel('price')" v-if="minPrice || maxPrice" title="取消选择" style="margin-right:10px;">
                    价格：<span>{{minPrice}}-{{maxPrice}}<em>×</em></span>
                  </a>
                </div>
              </li>
              <li v-if="productInfo.goodsClass.children">
                <div class="lside-name">分类</div>
                <div class="rside-navtitle">
                  <a v-for="(item, index) in productInfo.goodsClass.children" :key="index" @click="_jumpToPageByClassId(item.classId)">
                    {{item.hktName}}
                  </a>
                </div>
              </li>
              <li>
                <div class="lside-name">价格</div>
                <div class="rside-navtitle">
                  <a href="17rec-1.html" class="red">全部</a>
                  <span class="setprice">
                    <el-input type="text" v-model="minPrice" id="price-min" @input="minPrice = minPrice.replace(/[^0-9]/g,'')"></el-input> -
                    <el-input type="text" v-model="maxPrice" id="price-max" @input="maxPrice = maxPrice.replace(/[^0-9]/g,'')"></el-input>
                    <el-button @click="_jumpToPageByPrice()" id="btnprice">确定</el-button>
                  </span>
                </div>
              </li>
              <li>
                <div class="lside-name">排序方式</div>
                <div class="rside-navtitle some-px">
                  <a href="javascript:void(0)" class="red">默认</a>
                </div>
              </li>
            </ul>
          </div>
          
          <ul class="yourlike clearovermartb nobottompad">
            <li v-for="(item, index) in productInfo.products" :key="index">
              <a @click="_jumpToProductDetail(item.productId)" class="picbox">
                <img :src="item.coverPhoto" alt="" height="192px" width="192px">
              </a>
              <div class="elli color-change">
                <a @click="_jumpToProductDetail(item.productId)">{{item.prodName}}</a>
              </div>
              <span class="color-change">
                <a @click="_jumpToProductDetail(item.productId)" class="price">￥<span>{{item.price}}</span></a>
              </span>

              <div class="probottom">
                <a href="javascript:void(0);" @click="_addToCart(item)" class="buy">加入购物车</a>
                <i class="line"></i>
                <a href="javascript:void(0);" @click="_buyNow(item)" class="addcart">立即购买</a>
              </div>
            </li>
          </ul>
          
          <div class="pages">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="total">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { queryProduct, queryHousekeepingType, listGoodsClasses, saveStoreCart, saveWebsiteAccessLog } from '@/api/plateform/productApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'Product',
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      productInfo: {
        goodsClass: {},
        products: [],
        classPath: [],
        records: '',
        pages: []
      },
      minPrice: '',
      maxPrice: '',
      searchKey: '',
      state: '2002',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    this._initMethod()
  },
  methods: {
    _initMethod() {
      this.searchKey = this.$route.query.searchKey
      if (this.$route.query.hktId) {
        this._queryProductByCondition(this.$route.query.hktId, this.DEFAULT_PAGE, this.DEFAULT_ROWS)
        this._queryClassByClassId(this.$route.query.hktId)
      } else {
        this.minPrice = this.$route.query.minPrice
        this.maxPrice = this.$route.query.maxPrice
        this._queryProductByCondition('', this.DEFAULT_PAGE, this.DEFAULT_ROWS)
        this._queryClassByClassId()
      }
      this.websiteAccessLog()
      console.log(this.state)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._queryProductByCondition(this.$route.query.hktId, val, this.DEFAULT_ROWS)
    },
    _queryClassByClassId(_hktId) {
      const param = {
        page: -1,
        row: 100,
        hktId: _hktId
      }
      
      queryHousekeepingType(param).then(res => {
        if (!_hktId) {
          this.productInfo.goodsClass.children = res.data
          return
        }
        this.productInfo.goodsClass = res.data[0]
      }).catch(error => {
        console.log('请求失败处理', error)
      })
    },
    _queryClassesByClassIdPath(_classIdPath) {
      const param = {
        page: -1,
        row: 100,
        classIds: _classIdPath
      }
      
      listGoodsClasses(param).then(res => {
        const classPath = []
        const classIdPath = _classIdPath.split("-")
        for (let i = 0; i < classIdPath.length; i++) {
          for (let j = 0; j < res.data.length; j++) {
            if (classIdPath[i] === res.data[j].classId) {
              classPath.push(res.data[j])
            }
          }
        }
        this.productInfo.classPath = classPath
      }).catch(error => {
        console.log('请求失败处理', error)
      })
    },
    _queryProductByCondition(_classId, _page, _rows) {
      const param = {
        page: _page,
        row: _rows,
        hktId: _classId,
        minPrice: this.minPrice,
        maxPrice: this.maxPrice,
        prodNameLike: this.searchKey
      }
      
      queryProduct(param).then(res => {
        this.productInfo.total = res.total
        this.productInfo.records = res.records
        this.total = res.total
        this.currentPage = _page
        this.productInfo.products = res.data
      }).catch(error => {
        console.log('请求失败处理', error)
      })
    },
    _jumpToPageByClassId(_classId) {
      this.$router.push({ path: '/pages/plateform/product', query: { classId: _classId } })
    },
    _jumpToPageByPrice() {
      if (this.minPrice || this.maxPrice) {
        this._queryProductByCondition(this.$route.query.hktId, this.DEFAULT_PAGE, this.DEFAULT_ROWS)
      }
    },
    _jumpToPageByCancel(_type) {
      const minPrice = this.minPrice
      const maxPrice = this.maxPrice
      switch (_type) {
        case 'class':
          this.$router.push({ path: '/pages/plateform/product', query: { minPrice, maxPrice } })
          break
        case 'price':
          this.minPrice = ''
          this.maxPrice = ''
          this._queryProductByCondition(this.$route.query.hktId, this.DEFAULT_PAGE, this.DEFAULT_ROWS)
          break
      }
    },
    _jumpToProductDetail(_productId) {
      this.$router.push({ path: '/pages/plateform/productDetail', query: { productId: _productId } })
    },
    _addToCart(_product) {
      const param = {
        prodName: _product.prodName,
        productId: _product.productId,
        valueId: _product.valueId,
        storeId: _product.storeId,
        price: _product.price,
        shopId: _product.shopId,
        cartNum: "1"
      }
      
      saveStoreCart(param).then(res => {
        if (res.code === 0) {
          this.$message.success("加入购物车成功")
        } else if (res.code === 404) {
          this.$message.error(res.msg)
        } else {
          this.$message.error(res.data)
        }
      }).catch(error => {
        console.log('请求失败处理', error)
        this.$message.error(error)
      })
    },
    _buyNow(_product) {
      const param = {
        prodName: _product.prodName,
        productId: _product.productId,
        valueId: _product.valueId,
        storeId: _product.storeId,
        price: _product.price,
        shopId: _product.shopId,
        cartNum: "1"
      }
      
      saveStoreCart(param).then(res => {
        if (res.code === 0) {
          this.$message.success("加入购物车成功")
          this.$router.push({
            path: '/pages/plateform/order',
            query: {
              productId: _product.productId,
              shopId: _product.shopId,
              valueId: _product.valueId,
              goodsNum: 1
            }
          })
        } else if (res.code === 404) {
          this.$message.error(res.msg)
        } else {
          this.$message.error(res.data)
        }
      }).catch(error => {
        console.log('请求失败处理', error)
        this.$message.error(error)
      })
    },
    websiteAccessLog() {
      const user = this.$store.getters.user
      let param = {}
      
      if (user) {
        param = {
          loginName: user.name,
          loginId: user.userId,
          accessUrl: window.location.href,
          loginState: '1'
        }
      } else {
        param = {
          accessUrl: window.location.href,
          loginState: '0'
        }
      }
      
      saveWebsiteAccessLog(param).then(res => {
        if (res.code === 0) {
          return
        }
      }).catch(error => {
        console.log('请求失败处理', error)
        this.$message.error(error)
      })
    }
  }
}
</script>

<style scoped>
/* 保留原有样式 */
.navtitleright {
  margin-bottom: 15px;
}
.indbody {
  background: #fff;
  padding: 20px;
}
.recom-box {
  margin-bottom: 20px;
}
.part-price-sort {
  border: 1px solid #e6e6e6;
  margin-bottom: 20px;
}
.pps li {
  padding: 10px;
  border-bottom: 1px solid #e6e6e6;
}
.lside-name {
  float: left;
  width: 80px;
  color: #666;
}
.rside-navtitle {
  margin-left: 80px;
}
.rside-navtitle a {
  margin-right: 15px;
  color: #666;
}
.rside-navtitle a.red {
  color: #f00;
}
.setprice {
  margin-left: 15px;
}
.yourlike {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}
.yourlike li {
  width: 20%;
  padding: 0 10px;
  margin-bottom: 20px;
}
.picbox {
  display: block;
  margin-bottom: 10px;
}
.elli {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 5px;
}
.price {
  color: #f00;
  font-weight: bold;
}
.probottom {
  margin-top: 10px;
}
.buy, .addcart {
  display: inline-block;
  padding: 2px 10px;
  border: 1px solid #e6e6e6;
  color: #666;
}
.line {
  display: inline-block;
  width: 1px;
  height: 14px;
  background: #e6e6e6;
  margin: 0 5px;
  vertical-align: middle;
}
.pages {
  text-align: center;
  margin-top: 20px;
}
</style>